const rawDocumentCategories =[
    {"value":"", "label":""},
    {"value": "ACLS", "label":"ACLS"},
    {"value": "APPLICATION", "label":"Application"},
    {"value": "BLS", "label":"BLS"},
    {"value": "BIANNUAL_DISCLOSURES", "label":"Biannual Disclosures"},
    {"value": "BOARD_CERTIFICATION", "label":"Board Certification"},
    {"value": "CASE_LOG", "label":"Case Log"},
    {"value": "CME", "label":"CME"},
    {"value": "COLLABORATIVE_PLAN", "label":"Collaborative Plan"},
    {"value": "COLOR_PHOTO", "label":"Color Photo"},
    {"value": "CONTRACT", "label":"Contract"},
    {"value": "CONTRACT_CUSTOM", "label":"Contract - Custom"},
    {"value": "CONTRACT_STANDARD", "label":"Contract - Standard"},
    {"value": "CONTROLLED_DANGEROUS_SUBSTANCE", "label":"CDS"},
    {"value": "CREDENTIALING", "label":"Credentialing"},
    {"value": "CV", "label":"CV"},
    {"value": "DD214", "label":"DD214"},
    {"value": "DEA", "label":"DEA"},
    {"value": "DOP", "label":"DOP"},
    {"value": "DRIVERS_LICENSE", "label":"Driver's License"},
    {"value": "ECFMG_CERTIFICATE", "label":"ECFMG Certificate"},
    {"value": "EDUCATION_TRAINING", "label":"Education & Training"},
    {"value": "FPPE", "label":"FPPE"},
    {"value": "IMMUNIZATION", "label":"Immunization"},
    {"value": "INITIAL_ENROLLMENT", "label":"Initial Enrollment"},
    {"value": "INITIAL_ENROLLMENT_APPROVAL", "label":"Initial Enrollment Appr."},
    {"value": "INITIAL_PRIVILEGES", "label":"Initial Privileges"},
    {"value": "INITIAL_PRIVILEGES_APPROVAL", "label":"Initial Privileges Appr."},
    {"value": "MALPRACTICE_INSURANCE", "label":"Malpractice Ins."},
    {"value": "LICENSE", "label":"Medical License"},
    {"value": "OFFICE_LICENSE", "label":"Office License"},
    {"value": "OFFICE_PERMIT", "label":"Office Permit"},
    {"value": "ONBOARDING_AGREEMENT", "label":"Onboarding Agmt."},
    {"value": "ONBOARDING_DOCUMENTS", "label":"Onboarding Docs."},
    {"value": "OTHER", "label":"Other"},
    {"value": "PALS", "label":"PALS"},
    {"value": "PASSPORT", "label":"Passport"},
    {"value": "PAST_HOSPITAL_PRIVILEGES", "label":"Past Hospital Privileges"},
    {"value": "PRIVILEGES", "label":"Privileges"},
    {"value": "PRIVILEGES_APPROVAL", "label":"Privileges Approval"},
    {"value": "PROFILE_REPORT", "label":"Profile Report"},
    {"value": "PSV", "label":"PSV"},
    {"value": "RE_ENROLLMENT", "label":"Re-enrollment"},
    {"value": "SOCIAL_SECURITY_CARD", "label":"Social Security Card"},
    {"value": "TASK_RESOLUTION_REPORT", "label":"Task Resolution Report"},
    {"value": "TB_SCREENING", "label":"TB Screening"},
    {"value": "TERMINATION", "label":"Termination"},
    {"value": "TEST", "label":"Test"},
    {"value": "W9", "label":"W-9"},
  ];

const getRawDocumentCategories = (isH3Admin, authorities, isH3AdminRevenueTeamFile=false, isRevenueTeamSpanningFacilityFile=false, isRevenueTeamSpanningCarrierFile=false) => {
    if (isH3AdminRevenueTeamFile) {
        return rawDocumentCategories.filter((category) => {
            return category.value === "" || category.value === 'CONTRACT_CUSTOM' || category.value === 'CONTRACT_STANDARD';
        });
    }

    if (isRevenueTeamSpanningFacilityFile || isRevenueTeamSpanningCarrierFile) {
        return rawDocumentCategories.filter((category) => {
            return category.value === "" || category.value === 'INITIAL_ENROLLMENT' || category.value === 'RE_ENROLLMENT' || category.value === 'OTHER' || category.value === 'TERMINATION';
        });
    }

    if (isH3Admin || authorities.includes("PROVIDER_SENSITIVE_DETAILS_VIEW") || authorities.includes("PROVIDER_SENSITIVE_DETAILS_EDIT")) {
        return rawDocumentCategories.filter((category) => {
            return category.value !== 'CONTRACT_CUSTOM' && category.value !== 'CONTRACT_STANDARD';
        });
    }

    return rawDocumentCategories.filter((category) => {
        return category.value !== 'DRIVERS_LICENSE' && category.value !== 'CONTRACT_CUSTOM' && category.value !== 'CONTRACT_STANDARD';
    });
}

export default getRawDocumentCategories;